/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { TabPane } from '../styles/cpds-tab-style';

//types
import { CpdsTabPanetProps } from '../typings';

const Tab: React.FC<CpdsTabPanetProps> = (props) => {
  const { children, selected } = props;

  return <TabPane selected={selected}>{children}</TabPane>;
};

export { Tab };
